module.exports = __webpack_public_path__ + "img/03_map.56c37428.webp";